import { render, staticRenderFns } from "./CancerCoachingBookCoach.vue?vue&type=template&id=f6db0c06"
import script from "./CancerCoachingBookCoach.vue?vue&type=script&lang=js"
export * from "./CancerCoachingBookCoach.vue?vue&type=script&lang=js"
import style0 from "./CancerCoachingBookCoach.vue?vue&type=style&index=0&id=f6db0c06&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports